import { queryOptions, useQuery } from '@tanstack/react-query'
import { arkivinfoKeys } from '../queries/helpers'
import { arkivinfoApi } from '../queries/arkivinfo-api'

export { useArkivinfo }

const arkivinfoQueryOptions = (kvitteringId: string) =>
  queryOptions({
    queryKey: arkivinfoKeys.get(kvitteringId),
    queryFn: async ({ queryKey: [{ kvitteringId }] }) => {
      const { data } = await arkivinfoApi.getArkivinfo(kvitteringId)

      return data
    },
    enabled: !!kvitteringId,
  })

const useArkivinfo = (kvitteringId: string) =>
  useQuery(arkivinfoQueryOptions(kvitteringId))
